// Core
import React, { Component } from 'react';
// Templates
import Nav from '../templates/Nav/Nav';
// Components
import Logo from '../components/Logo/martinmade.svg';
import Button from '../components/Button/Button';
import Card from '../components/Card/Card';
// Data
import projectData from '../data/site.content';

class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            structure: projectData,
            services: projectData.services
        };
    }

    render() {
        const { structure, services } = this.state;

        return (
            <article>
                <ul>
                    <Card for={'card'}>
                        <img alt="martinmade.me logo" src={Logo} />
                        <h1>
                            UI.
                            <br />
                            UX.
                            <br />
                            Dev.
                        </h1>
                        <p>
                            <a href="mailto:info@martinmade.me?subject=I would like something martin made me">
                                info@martinmade.me
                            </a>
                        </p>
                    </Card>
                </ul>
            </article>
        );
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home.js